"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var ClotheColorName_1 = __importDefault(require("./ClotheColorName"));
var react_1 = require("react");
var AvatarContext_1 = __importDefault(require("../AvatarContext"));
var Color_1 = __importDefault(require("../Color"));
function ClotheColor(_a) {
    var maskID = _a.maskID;
    var color = react_1.useContext(AvatarContext_1.default).clotheColor;
    return jsx_runtime_1.jsx(Color_1.default, { maskID: maskID, color: getClothColor(color), fillRule: 'evenodd' }, void 0);
}
exports.default = ClotheColor;
function getClothColor(color) {
    if (color && color.startsWith('#'))
        return color;
    switch (color) {
        case ClotheColorName_1.default.Black:
            return '#262E33';
        case ClotheColorName_1.default.Blue01:
            return '#65C9FF';
        case ClotheColorName_1.default.Blue02:
            return '#5199E4';
        case ClotheColorName_1.default.Blue03:
            return '#25557C';
        case ClotheColorName_1.default.Gray02:
            return '#929598';
        case ClotheColorName_1.default.Heather:
            return '#3C4F5C';
        case ClotheColorName_1.default.PastelBlue:
            return '#B1E2FF';
        case ClotheColorName_1.default.PastelGreen:
            return '#A7FFC4';
        case ClotheColorName_1.default.PastelOrange:
            return '#FFDEB5';
        case ClotheColorName_1.default.PastelRed:
            return '#FFAFB9';
        case ClotheColorName_1.default.PastelYellow:
            return '#FFFFB1';
        case ClotheColorName_1.default.Red:
            return '#FF5C5C';
        case ClotheColorName_1.default.Pink:
            return '#FF488E';
        case ClotheColorName_1.default.White:
            return '#FFFFFF';
        case ClotheColorName_1.default.Gray01:
        default:
            return '#E6E6E6';
    }
}
